<script setup lang="ts">
type ButtonType = 'primary' | 'secondary'

defineProps<{
  href: string
  text: string
  type: ButtonType
  customClass?: string
}>()
</script>

<template>
  <a
    class="button block py-4 mb-2 w-full text-center rounded-1.5"
    :href="href"
    :class="[
      {
        'bg-red-150 text-white': type === 'primary',
        'border-[3px] border-black md:mb-2 mb-0 !leading-[19px]': type === 'secondary'
      },
      customClass
    ]"
  >
    {{ text }}
  </a>
</template>

<style scoped lang="sass"></style>
